<template>
    <div class="container ">
        <br/>
        <div class="row">
            <div class="col-md-6">
                <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="siteName" v-model="siteName" />
                    <label class="floating-label" for="siteName">單位名稱</label>
                </div>
                <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="userName" v-model="userName" />
                    <label class="floating-label" for="userName">姓名</label>
                </div>
                <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="userAccount" v-model="userAccount" :class="{ 'is-invalid': invalidAccount }" @input="resetValidation" />
                    <label class="floating-label" for="userAccount">受訓編號</label>
                    <div v-if="invalidAccount" class="invalid-feedback">
                        受訓編號必須是 5 碼英數組合
                    </div>
                    <div v-if="checkAccount" class="invalid-feedback">
                        該受訓編號已存在
                    </div>
                    <div v-if="errorMessage" class="invalid-feedback">
                        註冊失敗，請聯繫管理人員
                    </div>
                </div>
                <button class="btn btn-primary" @click="registerDo()" v-if="shouldShowButton">註冊</button>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {

    data() {
        return {
            systemName: window.VUE_APP_System, //recommend //behavior
            isDev: window.VUE_APP_Dev,
            lineLoginChannelID: '2002453323', // Replace this with your Line Login Channel ID
            userLoginType: 'line',
            checkAccount: false,
            errorMessage: false,
            userAccount: '',
            userName: '',
            siteName: '',
            userid: '',
            isVerify: false
           
        }
    },
    beforeMount() {
        this.userLoginType = localStorage.getItem("userLoginType");
        let lineResult = localStorage.getItem("LIFF_STORE:2002453323-20Lo31Kp:decodedIDToken");
        if (this.systemName == "recommend") {
            lineResult = localStorage.getItem("LIFF_STORE:2002453331-wK4xYK9O:decodedIDToken");
        }

        if (this.isDev != '1') {
            if (lineResult) {
                try {
                    const lineObject = JSON.parse(lineResult);
                    const linecode = lineObject.sub;
                    localStorage.setItem("linecode", linecode);
                    this.userid=linecode;
                    this.getUser();
                } catch (error) {
                    console.log(error)
                }
                // this.$router.push('/register');
            } else {
                self.$router.push({ name: "LoginPage" });
            }
        }
       
    },
    mounted() {
        this.systemName = window.VUE_APP_System;
        if (this.systemName == "recommend") {
                //運動建議
                this.sportType = '運動項目推薦'
            } else {
                //運動行為
                this.sportType = '運動行為調查'
            }
    },
    computed: {
        
        invalidAccount() {
            // 正則表達式匹配 5 碼英數組合
            return !/^[A-Za-z0-9]{5}$/.test(this.userAccount);
        },
        shouldShowButton() {
            return (
                this.userAccount !== '' &&
                this.userName !== '' &&
                this.siteName !== '' &&
                this.invalidAccount == false 
            );
        },
    },
    methods: {
        resetValidation() {
            this.checkAccount = false;
            this.errorMessage = false;
        },
        setUserDo() {
            const url = "https://api.line.me/oauth2/v2.1/verify";
            if (this.systemName == "recommend") {
                //運動建議
                this.lineLoginChannelID = '2002453331';
            }
          
            const postData = {
                id_token: this.userid,
                client_id: this.lineLoginChannelID,
            };

            // Send POST request using Axios
            axios
                .post(url, postData)
                .then((response) => {
                    console.log('response')
                    console.log(response)
                    const data = response.data;
                    if (data.sub) {
                        this.isSuccess = true;
                        this.userID = data.sub;
                        this.userName = data.name || "Unknown";
                        this.userPhoto = data.picture || "No photo available";
                        localStorage.setItem("linedata", data);
                        localStorage.setItem("linesub", data.sub);
                        localStorage.setItem("linename", data.name);
                        // alert('Line登入成功');
                    }
                })
                .catch((error) => {
                    console.log("Error:", error);
                    alert('Line登入失敗');
                });
        },
        getUser(){
            const self = this;
            console.log('register')
            // 呼叫API獲取資料
            axios.get('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/getUser', {
                    params: {
                        survey_type: self.systemName,
                        userId: self.userid, // 這裡設置您的條件
                    },
                })
                .then(response => {
                    console.log(response.data);
                    if(response.data){
                        console.log('aa')
                        self.isVerify = true;
                        self.$router.push({ name: "HomePage" });
                    }
                })
                .catch(error => {
                    console.error('無法獲取資料：', error)
                })
        },
        registerDo() {
            const self = this;
            const data = {
                survey_type: this.systemName,
                user_token: this.userid,
                user_login_type: this.userLoginType,
                userAccount: this.userAccount,
                siteName: this.siteName,
                userName: this.userName,
               
            };

            axios.post('https://147isrgvqd.execute-api.ap-northeast-1.amazonaws.com/postRegister', data)
            .then(response => {
                console.log(response.data);
                if (response.data){
                    if (response.data.Count >= 1){
                        self.checkAccount = true;
                    }else {
                        self.errorMessage = false;
                        self.checkAccount = false;
                        console.log("successfully!");
                        self.$router.push({ name: "HomePage" });
                    }
                }else {
                    self.errorMessage = true;
                }
                // alert("successfully!");
            })
            .catch(error => {
                self.errorMessage = true;
                console.error("save error" + error);
                // alert("註冊失敗");
            });

        },
    }
}
</script>